module.exports = __webpack_public_path__ + "img/Rüdersdorf.80ee1740.jpg";